import { useEffect } from 'react'

import navigate from 'utils/navigate'
import useCurrentUser from 'auth/useCurrentUser'
import { useLocation } from '@reach/router'

export const useIsPendingSurvey = () => {
  const [{ currentUser }] = useCurrentUser()

  const isSubscribed = currentUser?.subscribed
  const hasSubmittedSurvey =
    currentUser?.firstName && currentUser?.howDidYouHearAboutUs

  return isSubscribed && !hasSubmittedSurvey
}

export default () => {
  const isPendingSurvey = useIsPendingSurvey()
  const { pathname } = useLocation()
  const pathsToIgnore = /^\/(survey|checkout|subscribe|subscription\/confirming)(?!r)\/*/
  const redirectToSurvey = !pathsToIgnore.test(pathname)

  useEffect(() => {
    if (isPendingSurvey && redirectToSurvey) {
      navigate('/survey/')
    }
  }, [isPendingSurvey, redirectToSurvey])
}
